import { FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, Grid } from '@material-ui/core'
import { themePickerStyle } from './ThemePicker.style'
import energi from '../../img/energi.jpg'
import istid from '../../img/istid.jpg'
import klima from '../../img/klima.jpg'
import miljo from '../../img/miljo.jpg'
import { DataTheme } from 'src/Enums'

export interface ThemePickerProps {
  open: boolean
  handleClose: () => void
  handleThemeSelected: (dataTheme: DataTheme) => void
}

const defaultProps: ThemePickerProps = {
  open: false,
  handleClose: (): void => {},
  handleThemeSelected: (dataTheme: DataTheme): void => {}
}

export const ThemePicker: FC<ThemePickerProps> = (props: ThemePickerProps) => {
  const classes = themePickerStyle()
  const intl = useIntl()

  return (
    <Dialog open={props.open} onClose={props.handleClose} fullWidth maxWidth='md' aria-labelledby='form-dialog-title' className={classes.root}>
      <DialogTitle id='form-dialog-title'>
        <FormattedMessage id='themepicker.title' />
        <a href='https://novonordiskfonden.dk' target='_blank' rel='noreferrer noopener'>
          <img
            src='nnf.png'
            alt='Novo Nordisk Fonden logo'
            className={classes.nnfImage}
          />
        </a>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <FormattedMessage id='themepicker.description' />
        </DialogContentText>
        <Grid container className={classes.themes}>
          <Grid item xs={3} onClick={() => { props.handleThemeSelected(DataTheme.ICE_AGE) }}><img src={istid} className={classes.iceAgeImage} alt={intl.formatMessage({ id: 'theme.iceage' })} /></Grid>
          <Grid item xs={3} className={classes.themeText} onClick={() => { props.handleThemeSelected(DataTheme.ICE_AGE) }}><b><FormattedMessage id='theme.iceage' /></b><br /><FormattedMessage id='theme.iceage.description' /></Grid>
          <Grid item xs={3} onClick={() => { props.handleThemeSelected(DataTheme.CLIMATE) }}><img src={klima} className={classes.climateBorder} alt={intl.formatMessage({ id: 'theme.climate' })} /></Grid>
          <Grid item xs={3} className={classes.themeText} onClick={() => { props.handleThemeSelected(DataTheme.CLIMATE) }}><b><FormattedMessage id='theme.climate' /></b><br /><FormattedMessage id='theme.climate.description' /></Grid>
          <Grid item xs={3} onClick={() => { props.handleThemeSelected(DataTheme.ENERGY) }}><img src={energi} className={classes.energyBorder} alt={intl.formatMessage({ id: 'theme.energy' })} /></Grid>
          <Grid item xs={3} className={classes.themeText} onClick={() => { props.handleThemeSelected(DataTheme.ENERGY) }}><b><FormattedMessage id='theme.energy' /></b><br /><FormattedMessage id='theme.energy.description' /></Grid>
          <Grid item xs={3} onClick={() => { props.handleThemeSelected(DataTheme.ENVIRONMENT) }}><img src={miljo} className={classes.environmentBorder} alt={intl.formatMessage({ id: 'theme.environment' })} /></Grid>
          <Grid item xs={3} className={classes.themeText} onClick={() => { props.handleThemeSelected(DataTheme.ENVIRONMENT) }}><b><FormattedMessage id='theme.environment' /></b><br /><FormattedMessage id='theme.environment.description' /></Grid>
        </Grid>
        <Grid container className={classes.themes}>
          <Grid item xs={12} className={classes.actions}>
            <Button variant='contained' onClick={() => { props.handleThemeSelected(DataTheme.NONE) }}>
              <FormattedMessage id='themepicker.notheme' />
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

ThemePicker.defaultProps = defaultProps

export default ThemePicker
